import { render, staticRenderFns } from "./buddyCard.vue?vue&type=template&id=55606bae&"
import script from "./buddyCard.vue?vue&type=script&lang=js&"
export * from "./buddyCard.vue?vue&type=script&lang=js&"
import style0 from "./buddyCard.vue?vue&type=style&index=0&id=55606bae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports